import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue";
const _hoisted_1 = { class: "relative" };
const _hoisted_2 = { class: "w-full" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon");
    const _component_MenuButton = _resolveComponent("MenuButton");
    const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon");
    const _component_MenuItem = _resolveComponent("MenuItem");
    const _component_MenuItems = _resolveComponent("MenuItems");
    const _component_HeadlessMenu = _resolveComponent("HeadlessMenu");
    return (_openBlock(), _createBlock(_component_HeadlessMenu, {
        as: "div",
        class: "relative inline-block text-left w-full"
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_MenuButton, { class: "inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentNavItem?.text) + " ", 1),
                        _createVNode(_component_ChevronDownIcon, {
                            class: "absolute right-2 h-5 w-5",
                            "aria-hidden": "true"
                        })
                    ]),
                    _: 1
                })
            ]),
            _createTextVNode(),
            _createVNode(_Transition, {
                "enter-active-class": "transition ease-out duration-100",
                "enter-from-class": "transform opacity-0 scale-95",
                "enter-to-class": "transform opacity-100 scale-100",
                "leave-active-class": "transition ease-in duration-75",
                "leave-from-class": "transform opacity-100 scale-100",
                "leave-to-class": "transform opacity-0 scale-95"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_MenuItems, { class: "w-full z-40 absolute right-0 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                                    return (_openBlock(), _createBlock(_component_MenuItem, {
                                        key: item,
                                        as: "div",
                                        class: _normalizeClass(["flex justify-between items-center", [
                                                _ctx.currentNavItem?.name === item.name
                                                    ? 'bg-gradient-to-r from-blue-500 to-blue-700 text-white font-bold'
                                                    : 'text-gray-700',
                                                'block px-4 py-2 text-sm',
                                            ]]),
                                        onClick: ($event) => (_ctx.handleMenuItemClick(item.formPoint))
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("button", null, _toDisplayString(item.text), 1),
                                            _createTextVNode(),
                                            (_ctx.getFormSavedStatus(item.name))
                                                ? (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                                                    key: 0,
                                                    class: _normalizeClass(["h-5 w-5 mr-2",
                                                        _ctx.currentNavItem?.name === item.name
                                                            ? 'text-white'
                                                            : 'text-green-400'
                                                    ])
                                                }, null, 8, ["class"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, 1032, ["class", "onClick"]));
                                }), 128))
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ]),
        _: 1
    }));
}
